export const SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM';